import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalPage({ t, doc, testId }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section data-testid={testId} className="bg-brand-light pt-32 pb-20 md:pt-40 md:pb-28">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <Link
          to="/"
          data-testid="legal-back-home"
          className="inline-flex items-center gap-2 font-display font-bold text-sm text-brand-accent hover:gap-3 transition-all"
        >
          <ArrowLeft className="w-4 h-4" strokeWidth={2.5} />
          {t.footer.backHome}
        </Link>

        <h1
          data-testid="legal-title"
          className="font-display font-black text-brand-primary text-4xl sm:text-5xl tracking-tighter mt-6 leading-[1.05]"
        >
          {doc.title}
        </h1>
        <p data-testid="legal-effective" className="mt-3 font-display font-semibold text-xs uppercase tracking-wider text-brand-muted">
          {t.legal.effective}
        </p>
        <p data-testid="legal-entity" className="mt-6 text-sm text-brand-muted leading-relaxed border-l-2 border-brand-accent pl-4">
          {t.legal.entity}
        </p>
        <p className="mt-6 text-base md:text-lg text-brand-secondary leading-relaxed">{doc.intro}</p>

        <div className="mt-10 space-y-8">
          {doc.sections.map((s) => (
            <div key={s.h} data-testid="legal-section">
              <h2 className="font-display font-bold text-brand-primary text-lg md:text-xl tracking-tight">{s.h}</h2>
              <p className="mt-2 text-base text-brand-muted leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>

        <p className="mt-12 text-xs text-brand-muted italic">{t.legal.disclaimer}</p>
      </div>
    </section>
  );
}
